import { render, staticRenderFns } from "./OrigemTicket.vue?vue&type=template&id=37455abf"
import script from "./OrigemTicket.vue?vue&type=script&lang=js"
export * from "./OrigemTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports